
import { ICat } from "../model/Cat";
import ImageLoader from "./ImageLoader";

class Cat extends ImageLoader implements ICat {
  public name: ICat["name"] = "";
  public sex: ICat["sex"];
  public images: ICat["images"];

  constructor(name: ICat["name"], sex: ICat["sex"]) {
    super();
    this.name = name;
    this.images = super.loadImages("cats", name);
  }
}

export default Cat;